@if (isImpersonating()) {
  <lkt-impersonation-bar
    [testId]="testId()"
    [impersonatedName]="impersonatedName()"
    [profileLabel]="profileLabel()"
    [context]="context()"
    [adminName]="adminName()"
    (exit)="onExit()" />
}
